<template>
  <router-view/>
</template>
<style>
:root {
  --amplify-primary-color:#002060;
  --amplify-background-color:#f0f0f0
}
</style>
